<ng-container *ngIf="application$ | async as application; else emptyTemplate">
  <app-header-report [application]="application" (refresh)="onRefresh()"></app-header-report>
  <app-modal-body-report [application]="application"></app-modal-body-report>
</ng-container>
<ng-template #emptyTemplate>
  <div app-modal-content class="h-[80vh] w-[90vw] !p-0">
    <app-skeleton></app-skeleton>
  </div>
</ng-template>
